import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { RoleService } from '@d-services';
import { CoreUserService } from '@d-services/core/user.service';
import { getCurrentPermission } from '@d-store/app-config/app-config.selector';
import { AppState } from '@d-store/constant';
import { select, Store } from '@ngrx/store';
import { first, map, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
  constructor(
    private roleService: RoleService,
    private router: Router,
    private store: Store<AppState>,
    private userService: CoreUserService,
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.roleService.currentPermission
      ? this.checkPermission(route)
      : this.store.pipe(
          select(getCurrentPermission),
          first((val) => !!val),
          map((_) => this.checkPermission(route)),
        );
  }

  private checkPermission(route: ActivatedRouteSnapshot) {
    if (
      route.data['moduleCode'] &&
      this.roleService.getActionsByModuleCode(route.data['moduleCode'])
    ) {
      if (route.data['actionName']) {
        if (
          this.roleService.checkPermissionByAction(
            route.data['moduleCode'],
            route.data['actionName'],
          )
        ) {
          return true;
        } else {
          this.router.navigateByUrl('/home');

          return false;
        }
      }

      return true;
    }
    this.router.navigateByUrl('/home');

    return false;
  }
}
